const index = () => import(/* webpackChunkName: "herb" */ './Index');

export default {
  routes: [
    //项目
    {
      path: '/railage2019/2019/index',
      name: 'railage2019Index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/railage/v2019/router.js